import { useEffect } from "react";
import { populateBICookie } from "../../auth/Auth";
import { useLocation } from "react-router";

const usePopulateBICookie = () => {
  const location = useLocation();

  useEffect(() => {
    populateBICookie();
  }, [location]);
};

export default usePopulateBICookie;
